import { useEffect } from "react";
import { api, warnQuietly } from "@/lib/api";

/**
 * Quietly keep the server copy of the answers up to date.
 *
 * Debounced, and keyed on the primitives that describe where they are in the
 * flow rather than on the step object itself — that object is rebuilt on every
 * render, and depending on it would restart the timer endlessly. Autosave is
 * best-effort: a failure is logged and the customer is never blocked by it.
 */
export function useAutosave({
  sessionId,
  service,
  answers,
  stepIndex,
  phase,
  stepKey,
  totalSteps,
  atContactGate,
}) {
  useEffect(() => {
    if (!sessionId || !service || phase !== "wizard") return undefined;
    const timer = setTimeout(() => {
      api
        .saveSession(sessionId, {
          service,
          answers,
          step_index: stepIndex,
          step_key: stepKey,
          total_steps: totalSteps,
          reached_contact_gate: atContactGate,
        })
        .catch((error) => {
          warnQuietly("autosave failed", error);
        });
    }, 600);
    return () => clearTimeout(timer);
  }, [sessionId, service, answers, stepIndex, phase, stepKey, totalSteps, atContactGate]);
}
